import { useEffect, useState } from "react";
import {supabase} from "../supabaseClient";

export function useImages(table, order = "Date") {
    const [images, setImages] = useState([]);

    useEffect(() => {
        async function fetchImages() {
            const { data, error } = await supabase
                .from(table)
                .select('*')
                .order(order, { ascending: false });
            if(error){
                console.log(error);
            }else {
                setImages(data);
            }
        }
        fetchImages();
    }, [order, table]);

    return images;
}